import React from 'react';

import { SelectField, Step } from '../SteppedForm';

const StepFitout = (props) => {
  return (
    <Step
      id="fitout"
      title="Vehicle Fit-out Location"
      skip={(formdata) =>
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        formdata.vehicles[props.state.vehicle_index].carbuy ||
        !props.stateconfig().installspots
      }>
      {props.stateconfig().installspots ? (
        <SelectField
          id="fitoutloc"
          label="Prefered location for 13cabs equipment installation"
          values={props.stateconfig().installspots}
          required
        />
      ) : (
        ''
      )}
    </Step>
  );
};

export default StepFitout;
